import axios from 'axios';
import { previewHeaders } from '../../../lib/site';

const CHUNK = 2 * 1024 * 1024;
export const EDDM_ACCEPT = '.pdf,.ai,.eps,.png,.jpg,.jpeg';

const readChunk = (blob) => new Promise((resolve, reject) => {
  const fr = new FileReader();
  fr.onload = () => resolve(String(fr.result).split(',')[1]);
  fr.onerror = () => reject(new Error('Could not read file'));
  fr.readAsDataURL(blob);
});

// Chunked upload (2MB parts) → { id, filename, url, size }. endpoint: public store or staff store endpoint.
export const uploadEddmFile = async (endpoint, file, kind = 'artwork', onProgress) => {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  if (!['pdf', 'ai', 'eps', 'png', 'jpg', 'jpeg'].includes(ext)) throw new Error('Upload a PDF, AI, EPS, PNG or JPG file');
  if (file.size > 50 * 1024 * 1024) throw new Error('File is larger than 50MB');
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  let uploadId = null;
  for (let i = 0; i < total; i += 1) {
    const data = await readChunk(file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK)));
    const { data: res } = await axios.post(endpoint, { upload_id: uploadId, filename: file.name, content_type: file.type, index: i, total, data, kind }, { headers: previewHeaders() });
    uploadId = res.upload_id;
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
    if (res.complete) return res.file;
  }
  throw new Error('Upload did not complete');
};

export const fmtBytes = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
